import React from "react";
import styles from "./style.module.css";

import { Button } from "aible";

import { VIEW_TYPE } from "containers/View/reducer";

import AibleLogo from "images/Aible_Logo/Aible_Logo.png";
import pathFind from "images/tileIcons/walkthrough-dark.svg";
import Tour from "reactour";

export default class ChatTour extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isDisableNavigation: false };
  }
  render() {
    const {
      isOpen,
      dataset,
      updateIsOpenNewChat,
      step,
      updateType,
      updateStep,
      selectBlueprint,
      selectedBlueprintId,
      updateIsUpload,
      updateArtifactId,
      selectedArtifact
    } = this.props;

    const { isDisableNavigation } = this.state;

    const handleClickSection = (section) => {
      const clickableDiv = document.getElementById(section);

      if (clickableDiv) {
        clickableDiv.click();
      }
    };

    const setShowHighlight = (isShowHighlight) => {
      this.setState({ isDisableNavigation: !isShowHighlight });

      const highlightDiv = document.getElementById("mask-main");

      if (highlightDiv) {
        highlightDiv.style.display = isShowHighlight === true ? "block" : "none";
      }
    };

    const CLOSE_DELAY = 300;
    const OPEN_DELAY = 600;

    const steps = [
      {
        selector: "#mainApp",
        content: ({ goTo, inDOM }) => (
          <div className={styles.tContent}>
            <div className={styles.aibleLogo}>
              <img
                src={AibleLogo}
                style={{
                  width: "100%",
                  height: "auto"
                }}
              />
            </div>
            <div className={styles.tHeader + " " + styles.centered}>{"Welcome to Aible!"}</div>
            <div>
              {
                "Aible delivers the fastest and safest path to Enterprise Generative AI. Aible AI use cases let you quickly find the insights in your business data without requiring you to learn how to speak to Large Language Models."
              }
            </div>
            <div className={styles.logoWrapper}>
              <img
                src={pathFind}
                style={{
                  marginTop: "-2px",
                  width: "100%",
                  height: "auto"
                }}
              />
            </div>

            <div
              className={styles.tFooter}
              style={{
                width: "100%",
                justifyContent: "space-between"
              }}
            >
              <Button
                onClick={() => {
                  updateIsOpenNewChat(false);
                }}
              >
                {"Skip For Now"}
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  updateStep(step + 1);
                  setShowHighlight(true);
                }}
              >
                {"Show Me Around"}
              </Button>
            </div>
          </div>
        ),
        action: () => {
          if (selectedBlueprintId !== "CHATAIBLE_RAW_CHAT") {
            selectBlueprint("CHATAIBLE_RAW_CHAT");
          }
          if (selectedArtifact) {
            updateArtifactId(undefined);
          }
        },
        stepInteraction: false,
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#chat-type-select",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Easily switch context by changing use cases"}</div>
            <div>
              {
                "Each use case contains specific prompt tuning and leverages different technology like vector databases for Document Summarization and SQL generation commands for Natural Language Queries so you only have to focus on your task at hand."
              }
            </div>
            <div className={styles.sFooter}>
              <Button
                onClick={() => {
                  updateStep(step - 1);
                }}
              >
                {"Previous"}
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  selectBlueprint("CHATAIBLE_DOCUMENT_SUMMARIZATION");
                  setTimeout(() => updateStep(step + 1), 100);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        stepInteraction: false,
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#chat-type-select",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Document Summarization Walkthrough"}</div>
            <div>
              {"The use case has been updated to Document Summarization. Next we'll start by uploading a document."}
            </div>
            <div className={styles.sFooter}>
              <Button
                onClick={() => {
                  selectBlueprint("CHATAIBLE_RAW_CHAT");
                  setTimeout(() => updateStep(step - 1), 100);
                }}
              >
                {"Previous"}
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  updateStep(step + 1);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        stepInteraction: false,
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#chat-data-select",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Select the dataset or document set"}</div>
            <div>
              {
                "If this is your first time using Aible you will likely not have any documents uploaded yet. You can easily upload new documents here with the Create New Document Set option."
              }
            </div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button
                type="primary"
                onClick={() => {
                  updateIsUpload(true);
                  setTimeout(() => updateStep(step + 1), 100);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        stepInteraction: false,
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#chat-upload-document",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Upload a Document"}</div>
            <div>{"Click the Upload Document button to select the document you would like to summarize."}</div>
            <div>
              {
                "Supported file types include PDF, CSV, HTML, and Markdown. Once the upload completes, processing time will vary based on document size, the document will be ready for summarization."
              }
            </div>
            <div className={styles.sFooter}>
              <Button
                onClick={() => {
                  updateIsUpload(false);
                  setTimeout(() => updateStep(step - 1), 100);
                }}
              >
                {"Previous"}
              </Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#menuTab_datasets",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Manage the documents you upload"}</div>
            <div>
              {"All of the data you upload to this folder can be viewed, renamed, or deleted from the data tab."}
            </div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        stepInteraction: false,
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#chat-tone-select",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Chat Tone"}</div>
            <div>{"Chat tones enable you to choose the voice or style in which the language model responds."}</div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#chat-model-select",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Try different Language Models (Optional)"}</div>
            <div>
              {"Explore the behavior of different models by choosing from the list of available language models."}
            </div>
            <div>{"Note: Your organization's settings may limit you to a single available model."}</div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#chat-message-box",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Start Chatting"}</div>
            <div>{"After your documents are processed, you can start asking questions here."}</div>
            <div className={styles.sFooter}>
              <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
              <Button
                type="primary"
                onClick={() => {
                  updateIsOpenNewChat(false);
                }}
              >
                {"Finish"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      }
    ];

    return (
      <Tour
        steps={steps}
        isOpen={Boolean(isOpen)}
        onRequestClose={() => {
          updateIsOpenNewChat(false);
          updateIsUpload(false);
        }}
        goToStep={step}
        startAt={step}
        showNavigation={false}
        showButtons={false}
        closeWithMask={false}
        disableInteraction={false}
        rounded={5}
        accentColor={"#512e77"}
        highlightedMaskClassName={"helpMePlease"}
      />
    );
  }
}
